import axios, {
  AxiosRequestConfig,
  AxiosPromise,
  InternalAxiosRequestConfig,
} from 'axios';
import * as s2sAuth from '@/clients/s2s/s2sAuth';
import { keycloak } from '@/config';
import { logOutUser } from '../auth/samsungAccount';

const sbaasUrl = process.env.REACT_APP_SBAAS_BASE;
const baseUrl = `${
  sbaasUrl ? sbaasUrl : window.location.origin
}/apps/st-mdr/script`;

const expireMargin = 33;

const localAxios = axios.create();
localAxios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    s2sAuth.getS2SToken();
    return Promise.reject(error);
  },
);

localAxios.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    if (!keycloak.canRefresh()) {
      // need relogin
      logOutUser();
      return Promise.reject('User Credential not found or expired');
    }
    config.baseURL = baseUrl;
    const token = await s2sAuth.getS2SToken();
    config.headers['X-S2S-Token'] = `Bearer ${token}`;
    config.headers['X-Authorization-Method'] = 'SA-S2S-TOKEN';
    const exp = keycloak.getExpireIn();
    if (expireMargin > exp) {
      await keycloak.refreshToken();
    }
    config.headers.Authorization = `Bearer ${keycloak.instance.token}`;
    return Promise.resolve(config);
  },
  error => {
    return Promise.reject(error);
  },
);

export const http = {
  get<T = any>(url: string, option?: AxiosRequestConfig): AxiosPromise<T> {
    const config: AxiosRequestConfig = {
      method: 'GET',
      url: url,
      baseURL: baseUrl,
      ...option,
    };
    return localAxios(config);
  },

  post<T = any>(url: string, option?: AxiosRequestConfig): AxiosPromise<T> {
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: url,
      baseURL: baseUrl,
      ...option,
    };
    return localAxios(config);
  },

  put<T = any>(url: string, option?: AxiosRequestConfig): AxiosPromise<T> {
    const config: AxiosRequestConfig = {
      method: 'PUT',
      url: url,
      baseURL: baseUrl,
      ...option,
    };
    return localAxios(config);
  },

  delete<T = any>(url: string, option?: AxiosRequestConfig): AxiosPromise<T> {
    const config: AxiosRequestConfig = {
      method: 'DELETE',
      url: url,
      baseURL: baseUrl,
      ...option,
    };
    return localAxios(config);
  },
};

export const httpCode = (resObj: any) => {
  if (resObj.response && resObj.response.status) return resObj.response.status;
  return resObj;
};
